module.exports = __webpack_public_path__ + "img/banner.1cae4b6a.jpg";